/**
 * @file Re-exports the editable collection table component.
 */
import Collection from "./Collection";

export default Collection;
